// for mp and rr order
export const orderReceivableStatus = {
  NEW: 'NEW',
  READY_FOR_APPROVAL: 'READY_FOR_APPROVAL',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  PENDING_INVOICE: 'PENDING_INVOICE',
  INVOICED: 'INVOICED',
  PAID: 'PAID',
  VOID: 'VOID',
  UNCLAIMABLE: 'UNCLAIMABLE',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
};
